
import { Check, Star } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";

const TestimonialsPanel = () => {
  const testimonials = [
    {
      quote: "I'm excited to share that I've passed the interviews and secured the E7 level. I truly appreciate your guidance in ML system design and the mock sessions. I've benefited tremendously not only on the technical side but also in how to present my ideas clearly and persuasively. Thank you again for your time and support throughout this process.",
      author: "E7 from TikTok (secured offer at Meta)"
    },
    {
      quote: "Thank you so much for the time you spent. I gained a lot of insights on what I should do to improve.",
      author: "Meta ML Engineer"
    },
    {
      quote: "Coach has through knowledge on Machine learning. Being on both sides of ML interviews the coach posess strong knowledge on expectations of ML interviews across companies.",
      author: "Meta ML Candidate"
    },
    {
      quote: "Professional and thorough ML system design interview. The coach asked relevant questions to assess understanding and provided specific, actionable feedback for improvement. Clear guidance on how to strengthen system design skills. Highly valuable session",
      author: "Uber ML Candidate"
    },
    {
      quote: "Thanks for the great feedback! Immensely helpful discussion and I got a lot of value out of the session esp understanding the expectations around equations, trade-offs and prob formulation at L6/7 level.",
      author: "Senior Staff ML Engineer"
    },
    {
      quote: "Amazing coach. Very knowledgeable and gave relevant, level specific feedback!",
      author: "Meta E6 ML Candidate"
    },
    {
      quote: "I really appreciated how flexible Bharathi was in accommodating my request for a more open-ended discussion of the system design interview process. I gained valuable insights into what's expected at my level and learned which pitfalls to avoid and what goals to focus on to succeed in the interview. I would highly recommend Bharathi for system design preparation.",
      author: "Meta E4 PhD ML Candidate"
    },
    {
      quote: "Thank you for putting this together as well as writing so well on medium.",
      author: "ML Engineer"
    }
  ];

  const [api, setApi] = useState<any>(null);

  useEffect(() => {
    if (!api) return;

    const interval = setInterval(() => {
      api.scrollNext();
    }, 2000); // Changed to 2000 milliseconds (2 seconds)

    return () => clearInterval(interval);
  }, [api]);

  return (
    <div className="space-y-6">
      {/* Trust Badges */}
      <div className="flex gap-4 items-center justify-center p-4 bg-primary/5 rounded-lg">
        <div className="text-center">
          <div className="font-bold">50+</div>
          <div className="text-sm text-muted-foreground">ML Interviews</div>
        </div>
        <div className="h-8 w-px bg-border" />
        <div className="text-center">
          <div className="font-bold">FAANG</div>
          <div className="text-sm text-muted-foreground">Alumni Network</div>
        </div>
      </div>

      {/* Testimonials Carousel */}
      <Card className="p-4">
        <div className="flex justify-between items-center mb-3">
          <h3 className="font-semibold">What Engineers Say</h3>
          <a 
            href="https://prepfully.com/coaches/K4RRVK" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-600 hover:underline flex items-center text-lg font-bold gap-1"
          >
            View Coach Profile 
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
        <Carousel className="w-full" setApi={setApi}>
          <CarouselContent>
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={index}>
                <div className="p-1">
                  <Card className="p-4 bg-accent/50">
                    <div className="flex gap-1 mb-2 text-yellow-500">
                      <Star className="w-4 h-4 fill-current" />
                      <Star className="w-4 h-4 fill-current" />
                      <Star className="w-4 h-4 fill-current" />
                      <Star className="w-4 h-4 fill-current" />
                      <Star className="w-4 h-4 fill-current" />
                    </div>
                    <blockquote className="text-sm mb-3">"{testimonial.quote}"</blockquote>
                    <footer className="text-sm font-medium text-muted-foreground">
                      {testimonial.author}
                    </footer>
                  </Card>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center gap-2 mt-4">
            <CarouselPrevious className="static transform-none" />
            <CarouselNext className="static transform-none" />
          </div>
        </Carousel>
      </Card>
    </div>
  );
};

export default TestimonialsPanel;
